import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_WORKSPACE_MEMBERS = `${ENDPOINT_BASE}/e`
